import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from 'frontend/types';

export interface LandingLearningPath {
  slug: string;
  title: string;
  course_names: string[];
}

export interface LandingLearningPathsState {
  items: LandingLearningPath[];
}

const landingLearningPaths: Module<LandingLearningPathsState, RootState> = {
  namespaced: true,
  state: () => ({
    items: [] as LandingLearningPath[],
  }),
  getters: {},
  mutations: {
    setValue(state: LandingLearningPathsState, value: LandingLearningPath[]): void {
      Vue.set(state, 'items', value);
    },
  },
  actions: {},
};

export default landingLearningPaths;
